import { useDropdown } from '@calendly/ui/components/dropdown';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { colorTextAction } from '@calendly/ui/theme';
import { mergeRefs } from '@calendly/ui/utils/merge-refs';
import { useCallback } from 'react';
import { useFocusPortaledFilterFieldMenuOnOpen, usePortaledFilterFieldMenuFocusRef } from 'hooks/use_focus_portaled_filter_field_menu_on_open';
import { usePortaledMenuAnchor } from 'hooks/use_portaled_menu_anchor';
import { usePortaledMenuPosition } from 'hooks/use_portaled_menu_position';
import { FilterBody } from './filter_body';
import { DropdownButton, Container } from './styles';
import { getMeetingsFilterMenuPortalRoot } from '../../filter_menu_portal_root';
import { FILTER_FIELD_DROPDOWN_WIDTH, filterFieldDropdownMenuCss, portaledMenuShellCss } from '../../portaled_menu_styles';
const wrapperCss = "w1qbgzy2";
export const DropdownFilter = ({
  controlText,
  ...props
}) => {
  const [toggle, Dropdown, isExpanded, {
    dropdownRef
  }] = useDropdown();
  const portalRoot = getMeetingsFilterMenuPortalRoot();
  const {
    anchorRef
  } = usePortaledMenuAnchor();
  usePortaledMenuPosition(isExpanded, anchorRef, dropdownRef, {
    placement: 'bottom-start',
    defaultMenuWidth: FILTER_FIELD_DROPDOWN_WIDTH,
    useViewportBounds: true
  });
  useFocusPortaledFilterFieldMenuOnOpen(isExpanded, dropdownRef);
  const setMenuFocusRef = usePortaledFilterFieldMenuFocusRef(isExpanded, dropdownRef);
  const closeDropdown = useCallback(() => {
    toggle();
  }, [toggle]);
  const handleTriggerKeyDown = useCallback(event => {
    if (isExpanded) return;
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    event.preventDefault();
    toggle();
  }, [isExpanded, toggle]);
  const menu = isExpanded && <Dropdown>
      <FixedContainer ref={mergeRefs(dropdownRef, setMenuFocusRef)} fixedWhen root={portalRoot ?? undefined} className={portaledMenuShellCss} onClick={event => event.stopPropagation()}>
        <Container data-component="filter-dropdown-menu" className={filterFieldDropdownMenuCss}>
          <FilterBody {...props} toggleDropdown={closeDropdown} />
        </Container>
      </FixedContainer>
    </Dropdown>;
  return <>
      <DropdownButton ref={anchorRef} className={wrapperCss} onClick={toggle} onKeyDown={handleTriggerKeyDown} data-testid="filter-dropdown-trigger" aria-expanded={isExpanded} aria-haspopup="listbox">
        {controlText}
        {isExpanded ? <ArrowChevronUpMiniIcon color={colorTextAction} /> : <ArrowChevronDownMiniIcon color={colorTextAction} />}
      </DropdownButton>
      {menu}
    </>;
};

require("./dropdown_filter.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./dropdown_filter.js");